export const alternateLinks = [
  {
    href: 'https://6cs.fail/ru/',
    hreflang: 'x-default'
  },
  {
    href: 'https://6cs.fail/ru/',
    hreflang: 'ru'
  },
  {
    href: 'https://cs.fail/ru/',
    hreflang: 'ru-UA'
  },
  {
    href: 'https://cs.fail/uk/',
    hreflang: 'uk-UA'
  },
  {
    href: 'https://6cs.fail/pl/',
    hreflang: 'pl'
  },
  {
    href: 'https://cs.fail/de/',
    hreflang: 'de'
  },
  {
    href: 'https://cs.fail/en/',
    hreflang: 'en'
  },
  {
    href: 'https://6cs.fail/sv/',
    hreflang: 'sv'
  },
  {
    href: 'https://6cs.fail/pt-BR/',
    hreflang: 'pt-br'
  },
  {
    href: 'https://cs.fail/fr/',
    hreflang: 'fr'
  },
  {
    href: 'https://6cs.fail/ro/',
    hreflang: 'ro'
  },
  {
    href: 'https://6cs.fail/cs/',
    hreflang: 'cs'
  },
  {
    href: 'https://6cs.fail/tr/',
    hreflang: 'tr'
  },
  {
    href: 'https://cs.fail/es/',
    hreflang: 'es'
  }
];